import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LoanConflictResolutionDialogComponent } from './loan-conflict-resolution-dialog.component';
import { LoanUpdateConflictNotificationComponent } from './loan-update-conflict-notification.component';

@NgModule({
  declarations: [
    LoanConflictResolutionDialogComponent,
    LoanUpdateConflictNotificationComponent,
  ],
  imports: [
    CommonModule,
    NgbTooltipModule,
  ],
  exports: [LoanUpdateConflictNotificationComponent],
})
export class LoanUpdateConflictsModule {}
